import { render } from "./BlocksHistory.vue?vue&type=template&id=b9f269ba&scoped=true"
import script from "./BlocksHistory.vue?vue&type=script&lang=js"
export * from "./BlocksHistory.vue?vue&type=script&lang=js"

import "./BlocksHistory.vue?vue&type=style&index=0&id=b9f269ba&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b9f269ba"

export default script